const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
export const BillingQuery: any = {
    GetEArchiveEInvoice: Backofficebff + '/v1/billing/get-earchive-file',
    GetEDispatch: Backofficebff + '/v1/billing/get-edispatch-file',
};
